import { z } from "zod";

export const MAX_DISPLAY_NAME_LENGTH = 128;
export const MAX_DESCRIPTION_LENGTH = 256;

/**
 * Zod fragments for the two mutable custom-field text attributes, shared by the
 * create and edit form schemas so the length rules stay single-sourced. Each
 * schema composes these into its own `z.object`.
 */
export const displayNameSchema = z
  .string()
  .max(
    MAX_DISPLAY_NAME_LENGTH,
    `Display name must be ${MAX_DISPLAY_NAME_LENGTH} characters or fewer.`,
  );

export const descriptionSchema = z
  .string()
  .max(
    MAX_DESCRIPTION_LENGTH,
    `Description must be ${MAX_DESCRIPTION_LENGTH} characters or fewer.`,
  );
